import type { TooltipProps } from '@mui/material';
import type { FC } from 'react';

import { Tooltip } from '@mui/material';

type Props = Omit<TooltipProps, 'title'> & Pick<Partial<TooltipProps>, 'title'>;

export const OptionalTooltip: FC<Props> = ({
  children,
  title,
  ...tooltipProps
}) => (
  <>
    {title
      ? (
          <Tooltip title={title} {...tooltipProps}>
            {children}
          </Tooltip>
        )
      : (
          children
        )}
  </>
);
